var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1347 7.38277C17.5754 7.7252 17.6432 8.34543 17.2862 8.76809L10.6292 16.6476C10.445 16.8657 10.1725 16.998 9.88016 17.0114C9.58784 17.0248 9.30345 16.918 9.09838 16.7177L6.16931 13.8578C5.77184 13.4697 5.7777 12.8461 6.1824 12.4649C6.58709 12.0837 7.23737 12.0894 7.63484 12.4774L9.75755 14.5501L15.6901 7.52803C16.0472 7.10537 16.6939 7.04033 17.1347 7.38277Z",
    fill: "#12A482"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.5,
    stroke: "#12A482",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.0ae64dea46235d43cb1b5e7ba73b15d1.svg";
export { ForwardRef as ReactComponent };